
<ng-container *ngIf="isLoading">
  <div class="loader-box">
    <div class="loader-7"></div>
  </div>
</ng-container>



<div class="icon-with-badge">
  <i data-feather="message-square"></i>
  <span *ngIf="!isLoading" class="badge">{{ messageCount }}</span>
</div>
  <ul *ngIf="!isLoading" class="chat-dropdown onhover-show-div">
    <li>
      <i data-feather="message-square"></i>
      <h3 class="mb-0">Съобщения</h3>
    </li>
    <li *ngFor="let m of recentMessages">
      <div class="d-flex">
        <div (click)="onSelect(m)" class="flex-grow-1">
          <a>
            <span><b>{{m.senderProfileName}}</b></span>
            <p>{{m.subject}}</p>
            <small class="text-muted">{{formatDate(m.dateReceived)}}</small>
          </a>
        </div>
      </div>
    </li>
    <li *ngIf="recentMessages.length === 0" class="text-center">
      <p class="text-muted mb-0">Няма нови съобщения</p>
    </li>
    <li class="text-center">
      <button class="btn btn-primary" (click)="navigateToInbox()">Прегледай Всички</button>
    </li>
  </ul>

